import { render, staticRenderFns } from "./GlobalChooseShareledger.vue?vue&type=template&id=07b474e4&scoped=true"
import script from "./GlobalChooseShareledger.vue?vue&type=script&lang=js"
export * from "./GlobalChooseShareledger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b474e4",
  null
  
)

export default component.exports